module.exports = __webpack_public_path__ + "static/media/basketball-ball.7436cdb7.svg";